<template>
    <div class="row">
        <audio id="audio-message" :src="urlsound"></audio>
        <div v-if="contact && messages.length > 0" class="conversation">
            <div v-for="message in messages" :key="message.id" class="col-12">
                <div :class="message.to == contact.id ? 'd-flex justify-content-end' : 'd-flex justify-content-start'">
                    <div :class="`card-message p-2 m-2 ${message.to == contact.id ? 'user-destination received float-right' : 'user-auth sent right float-left'}`">
                        <p class="m-0 mb-2">
                            <span class="font-weight-bold float-left mr-3">
                                {{ message.to == contact.id ? 'Você' : (message.from_contact ? message.from_contact.name : 'Usuário') }}
                            </span>
                            <small class="font-weight-light float-right">{{ message.created_at | moment('DD/MM/YYYY HH:mm') }}</small>
                        </p>
                        <div class="chat-message-body">
                            <!-- Mantém a renderização do texto já utilizada pelo editor atual. -->
                            <p v-if="message.text" class="mb-1" v-html="message.text"></p>
                            <MessageAttachment :message="message" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="messages.length <= 0 && contact" class="conversation col-12">
            <h3 class="text-muted text-center" style="margin-top: 40% !important">
                Diga olá {{ type == 'contatos' ? `para ${contact.name}` : 'no grupo' }} 😀
            </h3>
        </div>
        <div v-if="!contact" class="conversation col-12">
            <div class="text-center" style="margin-top: 20% !important">
                <span v-if="box == 'suporte'">
                    <h3>Está com alguma dificuldade ou dúvida?</h3>
                    <h3>Manda pra gente que te ajudamos 😉</h3>
                </span>
                <h3 v-else>
                    Escolha {{ type == 'contatos' ? 'uma pessoa' : 'um grupo' }} ao lado para iniciar uma conversa.
                </h3>
            </div>
        </div>
        <div v-if="loadmessage" class="col-12 load-text py-2 d-flex justify-content-center chat-typing-overlay">
            <hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
        </div>
        <div v-if="writemessage" class="col-12 load-text row px-3 chat-typing-overlay">
            <hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
            <b v-if="contact" class="pr-2">{{ contact.name }} </b> está digitando
        </div>
    </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';
import MessageAttachment from './MessageAttachment';

export default {
    components: { HollowDotsSpinner, MessageAttachment },
    props: {
        contact: { type: Object },
        type: { type: String },
        box: { type: String },
        messages: { type: Array, required: true },
        loadmessage: { type: Boolean },
        writemessage: { type: Boolean, default: false },
    },
    data() {
        return { urlsound: `${window.location.protocol}//${window.location.host}/sound/message-pop-up.mp3` };
    },
    mounted() {
        this.scrollToBottom();
    },
    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                // A rolagem da área da conversa também é feita pelo componente pai.
                this.$emit('scroll-bottom');
            });
        },
        beep() {
            const audio = this.$el.querySelector('audio');

            if (audio) {
                const play = audio.play();

                if (play && typeof play.catch === 'function') {
                    play.catch(() => {});
                }
            }
        },
    },
    watch: {
        contact() {
            this.scrollToBottom();
        },
        messages() {
            this.scrollToBottom();
            this.beep();
        },
    },
};
</script>

<style scoped>
.card-message {
    position: relative; display: flex; flex-direction: column; min-width: 0; max-width: 95%;
    word-wrap: break-word; background-color: #fff; background-clip: border-box;
    border: 1px solid #fdfdff !important; border-radius: 1rem;
}
.chat-message-body { overflow-wrap: anywhere; word-break: break-word; }
.direct-chat-info { display: block; margin-top: 15px; }
.user-destination { background: #bbdefb; }
.user-auth { background: #b2dfdb; }
.user-auth.sent:before {
    content: ''; position: absolute; top: 0; left: -6px; width: 0; height: 0;
    border: 8px solid transparent; border-right-color: #b2dfdb; border-top-color: #b2dfdb;
}
.user-destination.received:before {
    content: ''; position: absolute; top: 0; right: -6px; transform: scaleY(-1); width: 0; height: 0;
    border: 8px solid transparent; border-left-color: #bbdefb; border-bottom-color: #bbdefb;
}
.chat-typing-overlay { position: sticky; background: aliceblue; bottom: 0; padding: 10px; opacity: .9; }
::-webkit-scrollbar { width: 5px; background: #f4f4f4; }
::-webkit-scrollbar-track { background: #f4f4f4; }
::-webkit-scrollbar-thumb { background: #979797; border-radius: 25em; }
</style>
